import { MessagesSquare, MapPinned, FileCheck2, KeyRound } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";

const STEPS = [
  {
    icon: MessagesSquare,
    title: "Konsultasi Kebutuhan",
    text: "Ceritakan rencana, anggaran, dan target waktu Anda. Kami dengarkan terlebih dahulu.",
  },
  {
    icon: MapPinned,
    title: "Survei dan Perencanaan",
    text: "Tim meninjau lokasi dan menyusun rencana kerja beserta estimasi yang rinci.",
  },
  {
    icon: FileCheck2,
    title: "Penawaran dan Persetujuan",
    text: "Anda menerima penawaran tertulis yang jelas untuk ditinjau dan disetujui.",
  },
  {
    icon: KeyRound,
    title: "Pengerjaan dan Serah Terima",
    text: "Pekerjaan dilaksanakan sesuai rencana, lalu diserahterimakan dengan pemeriksaan bersama.",
  },
];

export const Workflow = () => (
  <section id="alur" className="bg-mist" aria-label="Alur kerja">
    <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-12 lg:py-28">
      <Reveal className="mx-auto max-w-2xl text-center">
        <Eyebrow>Alur Kerja</Eyebrow>
        <h2 className="text-balance font-heading text-3xl font-extrabold leading-tight tracking-tight text-navy sm:text-4xl">
          Empat Tahap yang{" "}
          <span className="italic text-orange-500">Jelas dan Terukur</span>
        </h2>
      </Reveal>

      <ol
        data-testid="workflow-timeline"
        className="relative mt-14 grid gap-10 md:grid-cols-2 lg:grid-cols-4 lg:gap-8"
      >
        <div
          className="absolute left-0 right-0 top-7 hidden h-px bg-slate-300 lg:block"
          aria-hidden="true"
        />
        {STEPS.map((step, i) => (
          <Reveal key={step.title} delay={i * 0.1}>
            <li
              data-testid={`workflow-step-${i + 1}`}
              className="relative flex flex-col items-start lg:items-center lg:text-center"
            >
              <span className="relative z-10 flex h-14 w-14 items-center justify-center rounded-2xl bg-navy font-heading text-lg font-extrabold text-white shadow-lg shadow-navy/25 ring-4 ring-mist transition-colors duration-300">
                <step.icon className="h-6 w-6 text-orange-400" aria-hidden="true" />
              </span>
              <span className="mt-3 font-heading text-xs font-extrabold uppercase tracking-[0.2em] text-orange-600">
                Tahap {i + 1}
              </span>
              <h3 className="mt-1.5 font-heading text-lg font-bold text-navy">
                {step.title}
              </h3>
              <p className="mt-2 max-w-xs text-sm leading-relaxed text-slate-600">
                {step.text}
              </p>
            </li>
          </Reveal>
        ))}
      </ol>
    </div>
  </section>
);
